import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { LoadingSpinner } from "@/components/loading";
import { isLoggedIn } from "@/lib/http";

export const Route = createFileRoute("/_app")({
  component: RouteComponent,

  beforeLoad({ location: { searchStr, pathname } }) {
    if (isLoggedIn() !== true) {
      throw redirect({
        to: "/auth/signin",
        search: {
          redirect: pathname,
          redirectSearch: Object.fromEntries(
            new URLSearchParams(searchStr).entries(),
          ),
        },
      });
    }
  },
  pendingComponent: () => (
    <div className="flex h-screen w-screen grow items-center justify-center">
      <LoadingSpinner size={48} />
    </div>
  ),
});

function RouteComponent() {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
}
